import React from 'react';
import { BlockHeader } from '../EditInfoForm/EditInfoForm.style';
import DisplayText from 'components/ui-kits/DisplayText';
import Button from 'components/ui-kits/Button';
import Textarea from 'components/ui-kits/Form/Textarea';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { updateMerchantDescription } from 'services/merchantService';
import { useAppSelector } from 'app/hooks';
import Loader from 'components/Loader';
import { handleError, handleSuccess } from 'utils';
import { UPDATE_MESSAGE } from 'const/Message';
import { BlockContent } from './EditDescriptionForm.style';

const EditDescriptionForm = ({
  merchantDescription = '',
  onCloseModal
}: {
  merchantDescription?: string;
  onCloseModal: () => void;
}) => {
  const { merchantSlug } = useAppSelector((state) => state.user);
  const queryClient = useQueryClient();

  const { register, handleSubmit } = useForm({
    mode: 'onSubmit'
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: (data: { description: string }) =>
      updateMerchantDescription(merchantSlug, data),
    onSuccess: () => {
      queryClient.invalidateQueries('getMerchant');

      onCloseModal();

      handleSuccess(UPDATE_MESSAGE.UPDATE_MERCHANT_INFO_SUCCESS);
    },
    onError: handleError
  });

  const onSubmit = (data: { description: string }) => mutate(data);

  return (
    <>
      {isLoading && <Loader />}
      <form onSubmit={handleSubmit(onSubmit)}>
        <BlockHeader>
          <DisplayText fontSize="XL" fontWeight="BOLD">
            Modifier la description de votre commerce
          </DisplayText>
          <Button
            variant="primary"
            label="Enregistrer"
            fontWeight="BOLD"
            sizeType="s"
            isFluid={false}
            type="submit"
            letterSpacing="S"
          />
        </BlockHeader>
        <BlockContent>
          <Textarea
            defaultValue={merchantDescription}
            countLength={true}
            name="description"
            register={register}
            height="15rem"
          />
        </BlockContent>
      </form>
    </>
  );
};

export default EditDescriptionForm;
